import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { css } from '@emotion/react';
import { N60A, Y300, Y75 } from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
export var annotationPrefix = 'ak-editor-annotation';
export var AnnotationSharedClassNames = {
  focus: "".concat(annotationPrefix, "-focus"),
  blur: "".concat(annotationPrefix, "-blur"),
  draft: "".concat(annotationPrefix, "-draft")
};
var DY75 = 'rgb(111, 92, 37)';
var DY300 = '#ffd557';
var Y75a = 'rgba(255, 240, 179, 0.5)';
var Y200a = 'rgba(255, 196, 0, 0.82)';
var DY75a = 'rgba(111, 92, 37, 0.5)';
var DY200 = '#82641c';
export var AnnotationSharedCSSByState = function AnnotationSharedCSSByState(props) {
  return {
    focus: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    // Background is not coming through in confluence, suspecting to be caused by some specific combination of\n    // emotion and token look up\n\n    background: ", ";\n    border-bottom: 2px solid\n      ", ";\n    // TODO: https://product-fabric.atlassian.net/browse/DSP-4147\n    box-shadow: ", ";\n    cursor: pointer;\n  "])), themed({
      light: "var(--ds-background-accent-yellow-subtler, ".concat(Y75, ")"),
      dark: "var(--ds-background-accent-yellow-subtler, ".concat(DY75, ")")
    })(props), themed({
      light: "var(--ds-border-accent-yellow, ".concat(Y300, ")"),
      dark: "var(--ds-border-accent-yellow, ".concat(DY300, ")")
    })(props), "var(--ds-shadow-overlay, ".concat("1px 2px 3px ".concat(N60A, ", -1px 2px 3px ").concat(N60A), ")")),
    blur: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: ", ";\n    border-bottom: 2px solid\n      ", ";\n    cursor: pointer;\n  "])), themed({
      light: "var(--ds-background-accent-yellow-subtlest, ".concat(Y75a, ")"),
      dark: "var(--ds-background-accent-yellow-subtlest, ".concat(DY75a, ")")
    })(props), themed({
      light: "var(--ds-border-accent-yellow, ".concat(Y200a, ")"),
      dark: "var(--ds-border-accent-yellow, ".concat(DY200, ")")
    })(props))
  };
};
export var annotationSharedStyles = function annotationSharedStyles(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .ProseMirror {\n    .", " {\n      ", ";\n    }\n\n    .", " {\n      ", ";\n      cursor: initial;\n    }\n\n    .", " {\n      ", ";\n    }\n  }\n"])), AnnotationSharedClassNames.focus, AnnotationSharedCSSByState(props).focus, AnnotationSharedClassNames.draft, AnnotationSharedCSSByState(props).focus, AnnotationSharedClassNames.blur, AnnotationSharedCSSByState(props).blur);
};